"use client"

import { Link } from "react-router-dom"
import "./Hero.css"

function Hero({ onDemoClick }) {
  return (
    <section className="hero">
      <div className="background-pattern"></div>

      <div className="container">
        <div className="content">
          <h1 className="title">
            Seamless Sync
            <br />
            Between
            <br />
            Salesforce and HubSpot
          </h1>

          <p className="subtitle">
            Unify your data - automatically, securely,
            <br />
            and in real time
          </p>

          <div className="buttons">
            <Link to="/register" className="primary-button">
              Get Free Trial
            </Link>
            <button onClick={onDemoClick} className="secondary-button">
              Book a Demo
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
